import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import keyDown from '@mailobj-browser/front/js/events/types/keyDown.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import meta from '#utilities/js/ea/meta.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const wmInput = new WeakMap()
const { parseInt } = Number

const onKeyDown = object(listener, {
  type: keyDown,
  passive,
  task: (input, { key }) => {
    const { value } = input
    wmInput.set(input, key === 'Backspace' && value.at(-1) === ':')
  }
})

const onInput = object(listener, {
  type: input,
  passive,
  task: (
    input
  ) => {
    const { form, name, value, ownerDocument } = input

    if (wmInput.get(input)) {
      input.value = value.slice(0, -1)

      return
    }

    const target = name.slice(0, -9)// on supprime "_sec_text"
    const targetFieldSec = one(`input[name='${target}_sec']`, form)
    const metaTimeFormat = one(`meta[name="ea_s_date_hour"]`, ownerDocument)
    const [timeFormat] = metaTimeFormat ? meta('s_date_hour') : ['24']
    const valueStr = value.replace(/\s+/g, '')
    const [timeHour, timeMin] = timeFormat === '12' ? valueStr.slice(0, -2).split(':') : valueStr.split(':')
    let antePost
    let hour
    let targetFieldSecValue

    if (targetFieldSec) {
      if ((timeFormat === '24' && value.replace(/\s+/g, '').length < 5)
        || (timeFormat === '12' && value.replace(/\s+/g, '').length < 7)) {
        targetFieldSec.value = ''
      }

      if (value.length === 2) {
        input.value = `${value}:`
      }

      if ((value.length === 5 && timeFormat === '24') || (value.length >= 7 && timeFormat === '12')) {
        if (timeHour.length === 2 && timeMin.length === 2 && /^\d+$/.test(timeHour) && /^\d+$/.test(timeMin)) {
          antePost = timeFormat === '12' ? value.trim().replace(' ', '').slice(-2).toLowerCase() : null
          hour = timeFormat === '12' ? timeHour === '12' ? 0 : parseInt(timeHour, 10) : null

          if (antePost === 'am') {
            targetFieldSecValue = hour * 3600 + parseInt(timeMin, 10) * 60
          } else if (antePost === 'pm') {
            targetFieldSecValue = (hour + 12) * 3600 + parseInt(timeMin, 10) * 60
          } else {
            targetFieldSecValue = parseInt(timeHour, 10) * 3600 + parseInt(timeMin, 10) * 60
          }
          
          targetFieldSec.value = targetFieldSecValue
        }
      }
    }
  }
})

export default input => {
  onKeyDown.listen(input)
  onInput.listen(input)
}
